import { ILayoutE02Repositorio } from "../repositorio/e02.repositorio.interface";
import { IRequestAtivarLayoutPorId, IRequestAtualizarLayout, IRequestCriarLayout, IRequestObterLayoutPorId, IRequestObterLayouts, IRequestRemoverLayoutPorId } from "../repositorio/e02.repositorio.request";
import { IResponseAtivarLayoutPorId, IResponseAtualizarLayout, IResponseCriarLayout, IResponseObterLayoutPorId, IResponseObterLayouts } from "../repositorio/e02.repositorio.response";
import { ILayout02Servico } from "./e02.dominio.interface";

export class LayoutE02Servico implements ILayout02Servico {
  layoutE02Repositorio: ILayoutE02Repositorio;

  constructor(layoutE02Repositorio: ILayoutE02Repositorio) {
    this.layoutE02Repositorio = layoutE02Repositorio;
  }

  async obterLayouts(data: IRequestObterLayouts): Promise<IResponseObterLayouts> {
    const resposta = await this.layoutE02Repositorio.obterLayouts(data);
    return resposta.data;

  }

  async obterLayoutPorId(data: IRequestObterLayoutPorId): Promise<IResponseObterLayoutPorId> {
    const resposta = await this.layoutE02Repositorio.obterLayoutPorId(data);
    return resposta.data;
  }

  async removerLayoutPorId(data: IRequestRemoverLayoutPorId): Promise<void> {
    await this.layoutE02Repositorio.removerLayoutPorId(data);

  }

  async ativarLayoutPorId(data: IRequestAtivarLayoutPorId): Promise<IResponseAtivarLayoutPorId> {
    const resposta = await this.layoutE02Repositorio.ativarLayoutPorId(data);
    return resposta.data;
  }

  async criarLayout(data: IRequestCriarLayout): Promise<IResponseCriarLayout> {
    const resposta = await this.layoutE02Repositorio.criarLayout(data);
    return resposta.data;
  }

  async atualizarLayout(data: IRequestAtualizarLayout): Promise<IResponseAtualizarLayout> {
    const resposta = await this.layoutE02Repositorio.atualizarLayout(data);
    return resposta.data;
  }
}